import { z } from 'zod';

/**
 * Who told the ledger about a movement (P31).
 *
 * - `webhook` — RevenueCat's delivery.
 * - `member_sync` — the member's own "check again" (`POST /me/billing/sync`, F10),
 *   which reports no figures: RevenueCat's v2 amounts are USD aggregates.
 * - `staff` — the direct-order machine, every transition.
 * - `backfill` — the operations command replaying `billing_events`,
 *   `fee_payments` and `direct_payment_orders` after the ledger arrived.
 *
 * Because `(store, external_ref)` is unique, three sources can each report the
 * same movement and one row lands — the first one's `source` is kept.
 */
export const PAYMENT_SOURCES = ['webhook', 'member_sync', 'staff', 'backfill'] as const;

export const PaymentSourceSchema = z.enum(PAYMENT_SOURCES);

export type PaymentSource = (typeof PAYMENT_SOURCES)[number];

const SOURCE_SET: ReadonlySet<string> = new Set(PAYMENT_SOURCES);

export function isPaymentSource(value: string): value is PaymentSource {
  return SOURCE_SET.has(value);
}
